import { ReactNode, createContext } from "react";
import useGoogleCalendar, { GoogleEventDto } from "./hooks/useGoogleCalendar";

interface GoogleCalendarContextProviderProps {
    children: ReactNode;
}

export interface GoogleCalendarContextData {
    googleEvents: GoogleEventDto[];
    getGoogleStartUrl: (returnUrl?: string) => Promise<string>;
    connectGoogle: (returnUrl?: string) => Promise<void>;
    getGoogleEvents: (startUtc: string, endUtc: string) => Promise<GoogleEventDto[] | null>;
    setGoogleEvents: (items: GoogleEventDto[]) => void;
}

const initialState: GoogleCalendarContextData = {
    googleEvents: [],
    getGoogleStartUrl: async () => "",
    connectGoogle: async () => { },
    getGoogleEvents: async () => null,
    setGoogleEvents: () => { },
};

export const GoogleCalendarContext = createContext<GoogleCalendarContextData>(initialState);

export default function GoogleCalendarContextProvider({
    children,
}: GoogleCalendarContextProviderProps) {
    const {
        googleEvents,
        getGoogleStartUrl,
        connectGoogle,
        getGoogleEvents,
        setGoogleEvents,
    } = useGoogleCalendar();

    return (
        <GoogleCalendarContext.Provider
            value={{
                googleEvents,
                getGoogleStartUrl,
                connectGoogle,
                getGoogleEvents,
                setGoogleEvents,
            }}
        >
            {children}
        </GoogleCalendarContext.Provider>
    );
}